import axios from "../../axios_config";
import { BASE_API_URL } from "../endpoints";

export type RegistrationDraft = {
	name: string;
	secondName: string;
	email: string;
	password: string;
	confirmPassword: string;
	/** Optional place, filled by the shared country/city picker. */
	country: string;
	city: string;
	countryId: string | null;
	cityId: string | null;
};

const tokenOf = (data: { access_token?: string } | undefined): string => {
	if (!data?.access_token) throw new Error("No access token in the reply");
	return data.access_token;
};

export const login = async (email: string, password: string): Promise<string> => {
	const res = await axios.post(`${BASE_API_URL}/v1/auth/bycredentials`, {
		user_email: email,
		user_password: password,
	});
	return tokenOf(res.data);
};

export const sendRegistrationCode = async (d: {
	email: string;
	name: string;
	lang: string;
}): Promise<void> => {
	await axios.post(`${BASE_API_URL}/v1/auth/sendcode/registration`, {
		user_email: d.email,
		user_lang: d.lang,
		user_name: d.name,
	});
};

export const register = async (d: RegistrationDraft, code: string): Promise<string> => {
	const res = await axios.post(`${BASE_API_URL}/v1/auth/register`, {
		user_name: d.name.trim(),
		user_second_name: d.secondName.trim(),
		user_email: d.email,
		user_password: d.password,
		user_country: d.country,
		user_city: d.city,
		user_country_place_id: d.countryId,
		user_locality_place_id: d.cityId,
		user_role: "user",
		user_type: "user",
		verification_code: code.trim(),
	});
	return tokenOf(res.data);
};

/** Sends a reset code; the token it returns ties the next two steps to this request. */
export const sendResetCode = async (email: string, lang: string): Promise<string> => {
	const res = await axios.post(`${BASE_API_URL}/v1/auth/sendcode/reset`, {
		user_email: email,
		user_lang: lang,
	});
	if (!res.data?.verification_token) throw new Error("No verification token in the reply");
	return res.data.verification_token;
};

export const verifyResetCode = async (d: {
	email: string;
	code: string;
	token: string;
}): Promise<void> => {
	await axios.post(`${BASE_API_URL}/v1/auth/verify-code`, {
		user_email: d.email,
		verification_code: d.code.trim(),
		verification_token: d.token,
	});
};

export const resetPassword = async (d: {
	email: string;
	password: string;
	token: string;
}): Promise<string> => {
	const res = await axios.post(`${BASE_API_URL}/v1/auth/reset-password`, {
		user_email: d.email,
		user_password: d.password,
		verification_token: d.token,
	});
	return tokenOf(res.data);
};

export const errorStatus = (error: unknown): number | undefined =>
	(error as { response?: { status?: number } })?.response?.status;
